// Mirrors the backend's validatePhoneNumber Nigerian regex (smsModule/libs/utils.js).
const NIGERIAN_PHONE_REGEX = /^((0|\+?234)?)([7-9])([0-1])(\d)(\d{7})$/;

const ENTRY_SEPARATOR_REGEX = /[,;|\r\n\t]+/;
const WHITESPACE_REGEX = /\s+/;
const FORMATTING_CHARACTERS_REGEX = /[\s\-.()'"]/g;

function cleanPhoneNumber(rawToken) {
  return rawToken.replace(FORMATTING_CHARACTERS_REGEX, "");
}

export function isValidNigerianNumber(phoneNumber) {
  return NIGERIAN_PHONE_REGEX.test(phoneNumber);
}

function toInternationalFormat(phoneNumber) {
  if (phoneNumber.startsWith("+")) return phoneNumber.slice(1);
  if (phoneNumber.startsWith("234")) return phoneNumber;
  if (phoneNumber.startsWith("0")) return `234${phoneNumber.slice(1)}`;
  return `234${phoneNumber}`;
}

// A chunk like "0803 123 4567" is one number written with spaces, while
// "08031234567 08051234567" is two numbers separated by a space.
function splitChunkIntoTokens(chunk) {
  const chunkWithoutFormatting = cleanPhoneNumber(chunk);
  if (isValidNigerianNumber(chunkWithoutFormatting)) {
    return [chunkWithoutFormatting];
  }
  return chunk.split(WHITESPACE_REGEX).map(cleanPhoneNumber);
}

export function parseRecipients(rawText) {
  const validNumbers = [];
  const invalidNumbers = [];
  let duplicateCount = 0;

  if (typeof rawText !== "string" || rawText.trim() === "") {
    return { validNumbers, invalidNumbers, duplicateCount };
  }

  const seenNumbers = new Set();
  const tokens = rawText
    .split(ENTRY_SEPARATOR_REGEX)
    .flatMap(splitChunkIntoTokens)
    .filter((token) => token !== "");

  for (const token of tokens) {
    const isValid = isValidNigerianNumber(token);
    const dedupeKey = isValid ? toInternationalFormat(token) : token;

    if (seenNumbers.has(dedupeKey)) {
      duplicateCount += 1;
      continue;
    }
    seenNumbers.add(dedupeKey);

    if (isValid) {
      validNumbers.push(token);
    } else {
      invalidNumbers.push(token);
    }
  }

  return { validNumbers, invalidNumbers, duplicateCount };
}

export function summarizeNumbers(numbers, maxShown = 10) {
  const shownNumbers = numbers.slice(0, maxShown).join(", ");
  const hiddenCount = numbers.length - maxShown;
  return hiddenCount > 0 ? `${shownNumbers} +${hiddenCount} more` : shownNumbers;
}
